import { Observable } from 'rxjs';
import { LandingRewardsResponse } from '../models/landing-rewards.model';

export abstract class LandingRewardsRepository {
    abstract getLandingRewards(): Observable<LandingRewardsResponse>;
}
